import { render, staticRenderFns } from "./inputRadioItem.vue?vue&type=template&id=11a16f94"
import script from "./inputRadioItem.vue?vue&type=script&lang=js"
export * from "./inputRadioItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports